import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue'
import Login from '../views/Login.vue'

import Payment_Success from '../views/Payment_Success.vue'
import Payment_Error from '../views/Payment_Error.vue'

import Cabinet from '../views/Cabinet.vue'
import profile from '../components/cabinet/content/profile/profile.vue'
import security from '../components/cabinet/content/security.vue'
import top_players from '../components/cabinet/content/top_players/top_players.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Main
  },
/*  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      auth: false
    },
  },
  {
    path: '',
    name: 'cabinet',
    component: Cabinet,
    meta: {
      auth: true
    },
    children:[
      {
        path: 'profile',
        name: 'profile',
        meta:{
          name: 'Профиль'
        },
        component: profile
      },
      {
        path: 'security',
        name: 'security',
        meta:{
          name: 'Безопасность'
        },
        component: security
      },
      {
        path: 'top-players',
        name: 'top_players',
        meta:{
          name: 'Топ игроков'
        },
        component: top_players
      },
    ]
  },*/
  {
    path: '/payment-success',
    name: 'payment_success',
    component: Payment_Success
  },
  {
    path: '/payment-error',
    name: 'payment_error',
    component: Payment_Error
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
